export enum RatingScore {
  Good = 'good',
  Bad = 'bad',
  NotRated = 'no_rated',
}
